<template>
  <div class="vue-help-wrap">
    <div>
      <b-modal
      hide-footer
      id="help-modal"
      @hide="cancel"
      :modal-class="myclass">
        <template v-slot:modal-header>
          <span class="close-x" v-on:click="cancel()">×</span>
          <h3>VT Outages - Help</h3>
        </template>
        <div class="content-container">
          <div class="content">
            <section>
                <h4>Contact</h4>
                <div class="sub-section">
                  <div class="item">
                    <h5>How do I contact the VT Outages admin?</h5>
                    <p>
                      Send an email to: <a href="mailto:admin@vtoutages.org" title="Email admin@vtoutages.org">admin@vtoutages.org</a><br />
                      Note: this email is not for reporting power outages.  Please contact your utility provider directly to report outages.
                    </p>
                  </div>
                </div>
            </section>
            <section v-if="user">
                <h4>Utility</h4>
                <div class="sub-section">
                  <div class="item">
                    <h5>How do I upload outage data?</h5>
                    <p>
                      <ol>
                        <li>Click the "User" icon in the lower-right corner of the screen, and then click "Outage Data Upload".</li>
                        <li>You will see the Utility Outages modal.</li>
                        <li>If you are authorized to upload outages for more than one utility, use the drop-down to select a utility.</li>
                        <li>Optionally, enter the total number of events for the selected utility.</li>
                        <li>For each utility town, enter the total number of customers affected in that town.</li>
                        <li>For any towns with no customers affected, leave the default value of zero.</li>
                        <li>Click the "Update Now" button.</li>
                      </ol>
                    </p>
                  </div>
                </div>
            </section>
            <section v-if="user && userIsAdmin">
                <h4>Admin - Utility</h4>
                <div class="sub-section">
                  <div class="item">
                    <h5>How do I create a Utility?</h5>
                    <p>
                      <ol>
                        <li>Click the "User" icon in the lower-right corner of the screen, and then click "Admin".</li>
                        <li>You will see the Admin dashboard modal.</li>
                        <li>Click the "Utility" tab.</li>
                        <li>Where it says: "Add new utility", click the plus icon.</li>
                        <li>Enter the Name and Code values (required).</li>
                        <li>Enter the Description and URL values (optional).</li>
                        <li>Select a Utility type (required).</li>
                        <li>Click the "Create Utility" button.</li>
                      </ol>
                    </p>
                  </div>
                  <div class="item">
                    <h5>How do I edit a Utility?</h5>
                    <p>
                      <ol>
                        <li>Click the "User" icon in the lower-right corner of the screen, and then click "Admin".</li>
                        <li>You will see the Admin dashboard modal.</li>
                        <li>Click the "Utility" tab.</li>
                        <li>Use the dropdown to select a utility.</li>
                        <li>Edit the utility as needed (Name, Code, Description, URL, Utility type).</li>
                        <li>Add or remove town associations as needed</li>
                        <li>Click "Update Utility".</li>
                      </ol>
                    </p>
                  </div>
                  <div class="item">
                    <h5>How do I delete a Utility?</h5>
                    <p>
                      <ol>
                        <li>Click the "User" icon in the lower-right corner of the screen, and then click "Admin".</li>
                        <li>You will see the Admin dashboard modal.</li>
                        <li>Click the "Utility" tab.</li>
                        <li>Use the dropdown to select a utility.</li>
                        <li>Click the red "Delete" button.</li>
                        <li>Click the red "Confirm Delete" button.</li>
                      </ol>
                    </p>
                  </div>
                </div>
            </section>
            <section v-if="user && userIsAdmin">
                <h4>Admin - Town</h4>
                <div class="sub-section">
                  <div class="item">
                    <h5>How do I create a Town?</h5>
                    <p>
                      <ol>
                        <li>Click the "User" icon in the lower-right corner of the screen, and then click "Admin".</li>
                        <li>You will see the Admin dashboard modal.</li>
                        <li>Click the "Town" tab.</li>
                        <li>Where it says: "Add new town", click the plus icon.</li>
                        <li>Enter the Name and Code values (required).</li>
                        <li>Select a County (required).</li>
                        <li>Add town synonyms as needed.</li>
                        <li>Click the "Create Town" button.</li>
                      </ol>
                    </p>
                  </div>
                  <div class="item">
                    <h5>How do I edit a Town?</h5>
                    <p>
                      <ol>
                        <li>Click the "User" icon in the lower-right corner of the screen, and then click "Admin".</li>
                        <li>You will see the Admin dashboard modal.</li>
                        <li>Click the "Town" tab.</li>
                        <li>Use the dropdown to select a town.</li>
                        <li>Edit the town as needed (Name, Code, County).</li>
                        <li>Add or remove town synonyms as needed.</li>
                        <li>Click "Update Town".</li>
                      </ol>
                    </p>
                  </div>
                  <div class="item">
                    <h5>How do I delete a Town?</h5>
                    <p>
                      <ol>
                        <li>Click the "User" icon in the lower-right corner of the screen, and then click "Admin".</li>
                        <li>You will see the Admin dashboard modal.</li>
                        <li>Click the "Town" tab.</li>
                        <li>Use the dropdown to select a town.</li>
                        <li>Click the red "Delete" button.</li>
                        <li>Click the red "Confirm Delete" button.</li>
                      </ol>
                    </p>
                  </div>
                </div>
            </section>
            <section v-if="user && userIsAdmin">
                <h4>Admin - County</h4>
                <div class="sub-section">
                  <div class="item">
                    <h5>How do I create a County?</h5>
                    <p>
                      <ol>
                        <li>Click the "User" icon in the lower-right corner of the screen, and then click "Admin".</li>
                        <li>You will see the Admin dashboard modal.</li>
                        <li>Click the "County" tab.</li>
                        <li>Where it says: "Add new county", click the plus icon.</li>
                        <li>Enter the Name & Code values (required).</li>
                        <li>Click "Create County".</li>
                      </ol>
                    </p>
                  </div>
                  <div class="item">
                    <h5>How do I edit a County?</h5>
                    <p>
                      <ol>
                        <li>Click the "User" icon in the lower-right corner of the screen, and then click "Admin".</li>
                        <li>You will see the Admin dashboard modal.</li>
                        <li>Click the "County" tab.</li>
                        <li>Use the dropdown to select a county.</li>
                        <li>Edit the county as needed (Name & Code).</li>
                        <li>Click "Update County".</li>
                      </ol>
                    </p>
                  </div>
                  <div class="item">
                    <h5>How do I delete a County?</h5>
                    <p>
                      <ol>
                        <li>Click the "User" icon in the lower-right corner of the screen, and then click "Admin".</li>
                        <li>You will see the Admin dashboard modal.</li>
                        <li>Click the "County" tab.</li>
                        <li>Use the dropdown to select a county.</li>
                        <li>Click the red "Delete" button.</li>
                        <li>Click the red "Confirm Delete" button.</li>
                      </ol>
                    </p>
                  </div>
                </div>
            </section>
            <section v-if="user && userIsAdmin">
                <h4>Admin - Utility Type</h4>
                <div class="sub-section">
                  <div class="item">
                    <h5>How do I create a Utility Type?</h5>
                    <p>
                      <ol>
                        <li>Click the "User" icon in the lower-right corner of the screen, and then click "Admin".</li>
                        <li>You will see the Admin dashboard modal.</li>
                        <li>Click the "Utility Type" tab.</li>
                        <li>Where it says: "Add new utility type", click the plus icon.</li>
                        <li>Enter the Name and Code values (required).</li>
                        <li>Enter the Description (optional).</li>
                        <li>Click "Create Utility Type".</li>
                      </ol>
                    </p>
                  </div>
                  <div class="item">
                    <h5>How do I edit a Utility Type?</h5>
                    <p>
                      <ol>
                        <li>Click the "User" icon in the lower-right corner of the screen, and then click "Admin".</li>
                        <li>You will see the Admin dashboard modal.</li>
                        <li>Click the "Utility Type" tab.</li>
                        <li>Use the dropdown to select a utility type.</li>
                        <li>Edit the utility type as needed (Name, Code, Description).</li>
                        <li>Click "Update Utility Type".</li>
                      </ol>
                    </p>
                  </div>
                  <div class="item">
                    <h5>How do I delete a Utility Type?</h5>
                    <p>
                      <ol>
                        <li>Click the "User" icon in the lower-right corner of the screen, and then click "Admin".</li>
                        <li>You will see the Admin dashboard modal.</li>
                        <li>Click the "Utility Type" tab.</li>
                        <li>Use the dropdown to select a utility type.</li>
                        <li>Click the red "Delete" button.</li>
                        <li>Click the red "Confirm Delete" button.</li>
                      </ol>
                    </p>
                  </div>
                </div>
            </section>
            <section>
                <h4>Map Actions</h4>
                <div class="sub-section">
                  <div class="item">
                    <h5>How do I change the map view?</h5>
                    <p><strong>Desktop: </strong>On the right side of the screen, click "County", "Town" or "Utility", and the map view will change according to your selection.</p>
                    <p><strong>Mobile: </strong>At the bottom of the screen, click the "List" icon. Then, "County", "Town" or "Utility", and then click the "Map" icon. The map view will will reflect your selection.</p>
                  </div>
                  <div class="item">
                    <h5>How do I view outage details for an area of the map?</h5>
                    <p><strong>Desktop: </strong>Put your mouse over a County, Town or Utility, and a pop-up will provide outage detail for that area of the map.</p>
                    <p><strong>Mobile: </strong>Touch a County, Town or Utility, and a pop-up will provide outage detail for that area of the map.</p>
                  </div>
                </div>
            </section>
            <section>
                <h4>Data List</h4>
                <div class="sub-section">
                  <div class="item">
                    <h5>How do I filter the list data?</h5>
                    <p>In any of the list views, enter the name of a county, town or utility in the search box. The data list will be filtered to reflect the text that you have entered. to re-set the data list, remove the text from the search box.</p>
                  </div>
                </div>
            </section>
            <section>
                <h4>Outage History</h4>
                <div class="sub-section">
                  <div class="item">
                    <h5>How do I view past outage data?</h5>
                    <p>Click the "Data" icon in the lower-right corner of the screen. You will see outage events for all utilities for the last 48 hours. Use the date-picker controls to change the date-range. You can also use the radio buttons to view events per-utility or customers affected (aggregated or per-utility)</p>
                  </div>
                </div>
            </section>
            <section>
                <h4>User Actions</h4>
                <div class="sub-section">
                  <div class="item">
                    <h5>How do I Log in?</h5>
                    <p>Click the "Logon" icon in the lower-right corner of the screen. Enter your username and password, and then click the "Login" button.</p>
                  </div>
                  <div class="item">
                      <h5>How do I Log out?</h5>
                      <p>Click the "User" icon in the lower-right corner of the screen, and then click "Sign Out".</p>
                  </div>
                  <div class="item" v-if="user">
                      <h5>How do I change my password?</h5>
                      <p>
                        <ol>
                          <li>Log in using your existing password.</li>
                          <li>Click the "User" icon in the lower-right corner of the screen, and then click "Profile"</li>
                          <li>Click the "Change Password" tab.</li>
                          <li>Enter your current password.</li>
                          <li>Enter your new password and confirm your new password.</li>
                          <li>Cick "Submit"</li>
                          <li>You will see a confirmation that your password was changed.</li>
                        </ol>
                      </p>
                  </div>
                  <div class="item">
                      <h5>What do I do if I have forgotten my password?</h5>
                      <p>
                        <ol>
                          <li>Click the "Logon" icon in the lower-right corner of the screen. </li>
                          <li>In the "Login" Modal, click "Forgot password".</li>
                          <li>In the "Forgot Password" Modal, enter your username and then click "Send password reset code".</li>
                          <li>A verification code will been sent to the email address associated with that username. Check your email and make note of that verification code.</li>
                          <li>Enter the verification code that was emailed to you.</li>
                          <li>Enter your new password</li>
                          <li>Confirm your new password</li>
                          <li>Click "Change Password"</li>
                          <li>You will be taken back to the "Login" Modal.</li>
                          <li>You can now log in with your new password.</li>
                        </ol>
                      </p>
                  </div>
                </div>
            </section>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import vueMqMixin from "../mixins/VueMqMixin";

export default {
  name: 'HelpModal',
  mixins: [vueMqMixin],
  props: {
    user: Object,
    userIsAdmin: Boolean,
    hideModal: Function
  },
  async created() {
    Vue.nextTick(async () => this.showModal());
    this.myclass = this.isMobile() || this.isTablet() ? ['vt-outages-modal help isMobileOrTablet'] : ['vt-outages-modal help'];
  },
  data() {
    return {

    }
  },
  methods: {
      cancel() {
        this.hideModal();
      },
      async showModal() {
        await this.$bvModal.show('help-modal');
        this.adjustContentContainerHeight();
      },
      adjustContentContainerHeight() {
        const winHeight = window.innerHeight;
        const maxContentHeight = Math.round(winHeight * 0.8);
        const $contentContainer = document.querySelector('#help-modal .content-container');
        $contentContainer.style.height = `${maxContentHeight}px`;
      }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../assets/css/partials/_variables.scss";

#help-modal{
  .content-container{
    overflow-y: scroll;

    .content{
      section {
        padding: 10px;
        background-color: $lightGrey;

        h4 {
          font-weight: $bold;
          font-size: 22px;
        }

        .item{
          padding: 10px;
          background-color: $modalGrey;

          h5 {
            font-weight: $bold;
            font-size: 18px;
          }

          p{
            padding: 10px;
            background-color: $white;

            ol {
              margin-left: 20px;

              li {
                  list-style-type: decimal;
                  margin: 0 0 10px 0;
                  padding: 0;
                  line-height: 18px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
